import React from 'react';
import './Dropdown.css';
import { NavLink } from 'react-router-dom';

function Dropdown({ items, onItemClick }) {
	return (
		<ul className='dropdown-menu'>
			{items.map((item) => (
				<li className='dropdown-menu-item' key={item.path}>
					<NavLink
						to={item.path}
						className='dropdown-menu-item-link'
						onClick={onItemClick}
					>
						{item.title}
					</NavLink>
				</li>
			))}
		</ul>
	);
}

export default Dropdown;
